import { useHistory, Link } from "react-router-dom";
import { useState } from 'react';
import { Field, Formik } from 'formik';

/* Styles */
import styles from 'styles/login.module.scss';
import layoutStyles from 'styles/layout.module.scss';
import onboardingStyles from 'styles/onboarding.module.scss';
import formStyles from 'styles/experience-form.module.scss';
import cn from 'classnames';

/* i18n */
import { useIntl } from 'react-intl';

/* API */
import { postUpload } from 'lib/API';

/* Redux */
import { useDispatch } from 'react-redux';
import { setExperienceForm, setExperienceHasResume } from 'app/slices/experienceSlice';

/* Assets */
import ArrowRight from 'assets/images/Arrow_RightLight.svg';
import IllustrationGears from 'assets/images/Illustration_Gears.svg';
import IllustrationArchery from 'assets/images/Illustration_Archery.svg';
import IllustrationResume from 'assets/images/Illustration_Resume.svg';

/* Material UI and other UI Dependencies */
import OnboardingSteps from 'components/OnboardingSteps';
import {
  Box,
  Typography,
  CircularProgress,
  Modal,
  Backdrop,
  Fade
} from "@material-ui/core";
import { useSnackbar } from 'notistack';

/* Analytics */
import { trackEvent } from 'lib/analytics';

/* UI Components */
import UploadResume from 'components/forms/UploadResume';

export default function OnboardingResumeUpload() {

  const intl = useIntl();
  const urlPrefix = intl.locale === 'en' ? '' : `/${intl.locale}`;
  const history = useHistory();
  const [uploading, setUploading] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const handleDrop = (contents, ext) => {
    trackEvent('ONBOARDING_RESUME_UPLOAD');
    setUploading(true);
    postUpload({ contents, ext, type: 'resume' }).then(function(response) {
      dispatch(setExperienceForm(response.experience.value));
      dispatch(setExperienceHasResume(true));
      setUploading(false);
      history.push(`${urlPrefix}/onboarding/experience`);
    }).catch(function(e) {
      setUploading(false);
      enqueueSnackbar(intl.formatMessage({id:'app.error'}), {variant: 'error'});
    });
  }

  return (
    <>
      <Modal
        className={formStyles.modal}
        open={uploading}
        onClose={() => {}}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={uploading}>
          <div className={formStyles.modalPaper}>
            <Typography variant="body2" align="center">
              {intl.formatMessage(
                {id: 'experience.uploading'}
              )}
            </Typography>
            <Box m={2} />
            <CircularProgress />
          </div>
        </Fade>
      </Modal>
      <div className={styles.loginFlow__form__onboarding}>
        <Box px={3}>
          <Typography align="center" variant="h1"  gutterBottom>
            {intl.formatMessage({id:'onboarding.resume.title',description:'string'})}
          </Typography>
        </Box>        
        <OnboardingSteps activeStep={1} />
      </div>
      <hr className={layoutStyles.separatorBold} />
      <div className={onboardingStyles.resumeStepContainer}>
        <div className={onboardingStyles.imagesContainer}>
          <div className={onboardingStyles.imageContainer}>
            <img alt="Resume" className={cn(onboardingStyles.imageResume)} src={IllustrationResume} />
            <div className={onboardingStyles.imageTextContainer}>
              <Typography align="center" variant="caption"  gutterBottom>
                {intl.formatMessage({id:'onboarding.resume.weTake',description:'string'})}
              </Typography>
            </div>
          </div>
          <img alt="Arrow" className={cn(onboardingStyles.imageArrow)} src={ArrowRight} />
          <div className={onboardingStyles.imageContainer}>
            <img alt="Gears" className={cn(onboardingStyles.imageGears)} src={IllustrationGears} />
            <div className={onboardingStyles.imageTextContainer}>
              <Typography align="center" variant="caption"  gutterBottom>
                {intl.formatMessage({id:'onboarding.resume.analyze',description:'string'})}
              </Typography>
            </div>
          </div>
          <img alt="Arrow" className={cn(onboardingStyles.imageArrow)} src={ArrowRight} />
          <div className={onboardingStyles.imageContainer}>
            <img alt="Archery" className={cn(onboardingStyles.imageArchery)} src={IllustrationArchery} />
            <div className={onboardingStyles.imageTextContainer}>
              <Typography align="center" variant="caption"  gutterBottom>
                {intl.formatMessage({id:'onboarding.resume.generateRecommendations',description:'string'})}
              </Typography>
            </div>

          </div>
        </div>
        <div className={onboardingStyles.resumeLinkContainer}>
          <Typography align="center" variant="body1">
            {intl.formatMessage({id:'onboarding.resume.noResume',description:'string'})}
          </Typography>
          <Link to={`${urlPrefix}/onboarding/industry`} className={cn(layoutStyles.link, onboardingStyles.enterInfoLink)}>
            {intl.formatMessage({id:'onboarding.resume.enterInfo',description:'string'})}
          </Link>
        </div>
        <div className={onboardingStyles.resumeFullTextContainer}>
          <Typography align="center" variant="caption"  gutterBottom>
            {intl.formatMessage({id:'onboarding.resume.fullText',description:'string'})}
          </Typography>
        </div>
        <div className={onboardingStyles.resumeUploadContainer}>
          <Formik
            enableReinitialize={true}
            initialValues={{files: []}}
            onSubmit={() => {}}
          >
              {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    touched,
                    isSubmitting,
                    values,
                    submitForm,
                    setFieldValue
                }) => 
                {
                return (
                  <form style={{width: '100%'}} onSubmit={handleSubmit}>
                    <Field
                      name="files"
                      onDrop={handleDrop}
                      component={UploadResume}
                    />
                  </form>
          )}}
          </Formik>
        </div>
      </div>
    </>
  );
}